import { render, staticRenderFns } from "./ProductWaste.vue?vue&type=template&id=1e35e375&"
import script from "./ProductWaste.vue?vue&type=script&lang=js&"
export * from "./ProductWaste.vue?vue&type=script&lang=js&"
import style0 from "./ProductWaste.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports